import { Observable } from 'rxjs';
import { AuthService } from './../../../../auth/auth.service';
import { Component, OnInit, AfterViewInit, HostListener } from '@angular/core';
import { NavService } from '../../../services/nav.service';
import * as feather from 'feather-icons';
import { CustomizerService } from '../../../services/customizer.service';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss'],
})
export class ContentLayoutComponent implements OnInit, AfterViewInit {

  isLoggedIn$: Observable<boolean>;

  constructor(public navServices: NavService, public customizer: CustomizerService, public authService: AuthService) {
    this.isLoggedIn$ = authService.isLoggedIn
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      feather.replace();
    });
  }


}
